/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_scatter_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online scatter plot maker. Paste X,Y pairs to get an instant scatter chart and see the relationship between two variables.`)
};

const es_scatter_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador gratuito de diagramas de dispersión online. Pega pares X,Y para obtener un gráfico de dispersión instantáneo y ver la relación entre dos variables.`)
};

const de_scatter_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Streudiagramm-Ersteller. Fügen Sie X,Y-Wertepaare ein und erhalten Sie sofort ein Streudiagramm, um die Beziehung zwischen zwei Variablen zu sehen.`)
};

const nl_scatter_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online spreidingsdiagrammaker. Plak X,Y-paren om direct een spreidingsdiagram te krijgen en de relatie tussen twee variabelen te zien.`)
};

const fr_scatter_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur gratuit de nuage de points en ligne. Collez des paires X,Y pour obtenir instantanément un nuage de points et voir la relation entre deux variables.`)
};

const it_scatter_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore gratuito di grafici a dispersione online. Incolla coppie X,Y per ottenere un grafico a dispersione istantaneo e vedere la relazione tra due variabili.`)
};

const pt_br2_scatter_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador gratuito online de gráfico de dispersão. Cole pares X,Y para obter um gráfico de dispersão instantâneo e ver a relação entre duas variáveis.`)
};

const pt_scatter_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador gratuito de gráficos de dispersão online. Cole pares X,Y e obtenha instantaneamente um gráfico de dispersão para ver a relação entre duas variáveis.`)
};

const ja_scatter_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンライン散布図作成ツール。X, Yのペアを貼り付けると、即座に散布図が得られ、2つの変数の関係を確認できます。`)
};

const zh_scatter_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线散点图制作工具。粘贴 X,Y 数据对即可获得即时散点图，查看两个变量之间的关系。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const scatter_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.scatter_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("scatter_meta_description", locale)
	if (locale === "en") return en_scatter_meta_description(inputs)
	if (locale === "es") return es_scatter_meta_description(inputs)
	if (locale === "de") return de_scatter_meta_description(inputs)
	if (locale === "nl") return nl_scatter_meta_description(inputs)
	if (locale === "fr") return fr_scatter_meta_description(inputs)
	if (locale === "it") return it_scatter_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_scatter_meta_description(inputs)
	if (locale === "pt") return pt_scatter_meta_description(inputs)
	if (locale === "ja") return ja_scatter_meta_description(inputs)
	return zh_scatter_meta_description(inputs)
};